import { Events } from '@diziner/Events';
export class GoogleAnalytics {
    // private readonly _assignGlobalToLocalInterval: number;
    constructor(trackingCode) {
        this._trackingCode = trackingCode;
        const scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = 'https://www.googletagmanager.com/gtag/js?id=' +
            trackingCode;
        GoogleAnalytics.addListeners();
    }
    static addListeners() {
        Events.Issue.NavigatedToPageIndex.subscribe(GoogleAnalytics.navigatedToPageIndex);
    }
    static navigatedToPageIndex(index) {
        if (typeof window.ga === 'undefined'
            || GoogleAnalytics._pageIndexesCounted.indexOf(index) !== -1) {
            return;
        }
        window.ga.getAll()[0].set('page', window.location.toString().replace(window.location.origin, ''));
        window.ga.getAll()[0].send('pageview');
        GoogleAnalytics._pageIndexesCounted.push(index);
    }
}
GoogleAnalytics._pageIndexesCounted = [];
export default GoogleAnalytics;
